import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

/** 타이포 중심 빈 상태 — 일러스트/아이콘 없음 */
export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <Box sx={{ textAlign: 'center', py: 'var(--space-10)', px: 'var(--space-6)' }}>
      <Typography sx={{ fontSize: 'var(--size-md)', fontWeight: 700, color: 'var(--fg-secondary)' }}>
        {title}
      </Typography>
      {description && (
        <Typography sx={{ fontSize: 'var(--size-sm)', color: 'var(--fg-tertiary)', mt: 'var(--space-2)' }}>
          {description}
        </Typography>
      )}
      {action && <Box sx={{ mt: 'var(--space-5)' }}>{action}</Box>}
    </Box>
  );
}
